
import React from 'react';
import { RrwebSession } from '@/hooks/useRrwebSessions';
import SessionCard from './SessionCard';

interface SessionGridProps {
  sessions: RrwebSession[];
  selectedSessions?: RrwebSession[];
  onSelectSession?: (session: RrwebSession) => void;
  onPreviewSession?: (session: RrwebSession) => void;
  isLoading?: boolean;
}

const SessionGrid = ({ 
  sessions, 
  selectedSessions = [], 
  onSelectSession, 
  onPreviewSession,
  isLoading = false 
}: SessionGridProps) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="bg-editor-medium border border-editor-light rounded-lg p-4 animate-pulse">
            <div className="aspect-video bg-editor-dark rounded-lg mb-3" />
            <div className="space-y-2">
              <div className="h-4 bg-editor-dark rounded w-3/4" />
              <div className="h-3 bg-editor-dark rounded w-1/2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">📹</div>
        <h3 className="text-lg font-medium text-white mb-2">No recording sessions found</h3>
        <p className="text-gray-400 text-sm">
          Start by recording your screen to create sessions that can be added to projects.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {sessions.map((session) => (
        <SessionCard
          key={session.id}
          session={session}
          isSelected={selectedSessions.some(s => s.id === session.id)}
          onSelect={onSelectSession}
          onPreview={onPreviewSession}
        />
      ))}
    </div>
  );
};

export default SessionGrid;
